import { ImpersonatedBroker } from '@/contexts/masterAdmin';

export function filterBrokers(brokers: ImpersonatedBroker[], query: string): ImpersonatedBroker[] {
  const q = query.trim().toLowerCase();
  if (!q) return brokers;
  return brokers.filter(
    (b) => b.officeName.toLowerCase().includes(q) || b.name.toLowerCase().includes(q),
  );
}

export function getBrokerInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((w) => w[0])
    .join('')
    .toUpperCase();
}
